/** The ranges parsePeriodRange can resolve. CUSTOM is not one of them - it means "dates already set". */
export const NAMED_PERIOD_RANGES = [
  'TODAY',
  'LAST_7_DAYS',
  'LAST_15_DAYS',
  'LAST_30_DAYS',
  'CURRENT_MONTH',
  'LAST_90_DAYS',
];

/**
 * Which period a screen should open on when another screen hands it a selection.
 *
 * Two failures this prevents, both found in review:
 *
 * An unknown name must not reach parsePeriodRange. That function looks the name up in an enum, and a miss
 * yields invalid dates - so a stale or hand-edited URL would send null dates to the API rather than
 * falling back to a sane default.
 *
 * Explicit dates with no valid name are a CUSTOM range, not the default. Answering LAST_30_DAYS there is
 * what let the form's mount-time submit recompute over a handed-over range and quietly describe the last
 * thirty days instead of the period the producer clicked on.
 */
export const resolveInitialPeriodRange = (
  periodRange: string | undefined,
  hasExplicitDates: boolean,
): string => {
  if (periodRange && NAMED_PERIOD_RANGES.includes(periodRange))
    return periodRange;

  return hasExplicitDates ? 'CUSTOM' : 'LAST_30_DAYS';
};
